import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class WebsiteCriteria extends FilterCriteria {
  public override title = 'Website';
  public override type: FilterTypes = FilterTypes.Website;
  hasWebsite: boolean = null;
  noWebsite: boolean = null;

  public override validate(): boolean {
    return !(this.hasWebsite == null && this.noWebsite == null);
  }

  public override toString(): string {
    let text = '';
    if (this.hasWebsite) {
      text += 'Website';
    } else if (this.noWebsite) {
      text += 'No Website';
    }
    return text;
  }
}
